import { useMutation } from '@tanstack/react-query'
import { updateContent } from '../index'

const useUpdateContent = () =>
  useMutation({
    mutationFn: updateContent,
  })

export default useUpdateContent
